import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { BiSolidDashboard, BiSolidReport } from "react-icons/bi";
import {
  TbBrandGoogleAnalytics,
  TbMessageChatbot,
  TbReportMedical,
} from "react-icons/tb";
import { LiaUsersSolid } from "react-icons/lia";
import { IoSettingsOutline } from "react-icons/io5";
import { PiChats } from "react-icons/pi";
import { useUser } from "../config/userProvider";
import {
  FaExclamationTriangle,
  FaUserCheck,
  FaUserShield,
  FaWpforms,
} from "react-icons/fa";
import {
  FaCircleCheck,
  FaDollarSign,
  FaRegShareFromSquare,
  FaUsersGear,
  FaUsersViewfinder,
} from "react-icons/fa6";
import { removeCookie } from "../config/webStorage";
import { MdLeaderboard, MdOutlineQuiz } from "react-icons/md";
import { CiBoxList } from "react-icons/ci";
import PortalSelector from "./portalSelector";
import { File, Subscript, SwatchBook } from "lucide-react";
import { FcSurvey } from "react-icons/fc";
import { RiSurveyFill } from "react-icons/ri";

const Sidebar = () => {
  const { userData } = useUser();
  const location = useLocation();
  const [openDropdowns, setOpenDropdowns] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const updatedOpenDropdowns = {};
    NavigationData.forEach((item) => {
      if (
        item.subMenu &&
        item.subMenu.some((subItem) => subItem.location === location.pathname)
      ) {
        updatedOpenDropdowns[item.title] = true;
      }
    });
    setOpenDropdowns(updatedOpenDropdowns);
  }, [location.pathname, userData]);

  const toggleDropdown = (title) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const permissions = userData?.permissions || [];

  const NavigationData = [
    {
      title: "Dashboard",
      icon: <BiSolidDashboard />,
      location: "/hrms/dashboard",
      permission: "dashboard",
    },
    {
      title: "Interviews",
      icon: <LiaUsersSolid />,
      location: "/interview-queue",
      permission: "interview",
    },
    {
      title: "Applications",
      icon: <LiaUsersSolid />,
      location: "/applications",
      permission: "application",
    },
    {
      title: "Resumes",
      icon: <File />,
      location: "/resumes",
      permission: "resume",
    },
    {
      title: "Batches",
      icon: <TbReportMedical />,
      location: "/batches",
      permission: "batch",
    },
    {
      title: "Candidates",
      icon: <FaUsersGear />,
      location: "/candidates",
      permission: "candidate",
    },
    {
      title: "Trainees",
      icon: <FaUsersViewfinder />,
      location: "/trainees",
      permission: "trainee",
    },
    // {
    //   title: "Joiners",
    //   icon: <TbMessageChatbot />,
    //   location: "/joiners",
    //   permission: "joiner",
    // },
    {
      title: "Employees",
      icon: <FaUserCheck />,
      location: "/employees",
      permission: "employee",
    },
    {
      title: "Teams",
      icon: <FaUserShield />,
      location: "/teams",
      permission: "team",
    },
    {
      title: "Analytics",
      icon: <TbBrandGoogleAnalytics />,
      location: "/analytics",
      permission: "analytics",
    },
    {
      title: "Enquiries",
      icon: <MdOutlineQuiz />,
      location: "/enquiries",
      permission: "b2b",
    },
    {
      title: "Joinees",
      icon: <FaUserCheck />,
      location: "/joinees",
      permission: "joinee",
    },
    {
      title: "Recruiters",
      icon: <FaUserCheck />,
      location: "/recruiters",
      permission: "recruiter",
    },
    {
      title: "Past Joining",
      icon: <FaUsersGear />,
      location: "/past-joining",
      permission: "joinee",
    },
    {
      title: "Chats",
      icon: <PiChats />,
      location: "/chats",
      permission: "chat",
    },
    {
      title: "Onboarding List",
      icon: <CiBoxList />,
      location: "/onboarding-list",
      permission: "employee",
    },
    {
      title: "Leaderboard",
      icon: <MdLeaderboard />,
      location: "/recruiter/leaderboard",
      permission: "application",
    },
    {
      title: "Reference",
      icon: <FaRegShareFromSquare />,
      location: "/recruiter/dashboard",
      permission: "application",
    },
    {
      title: "Online Applications",
      icon: <FaWpforms />,
      location: "/online-applications",
      permission: "online_application",
    },
    {
      title: "Survey",
      icon: <RiSurveyFill />,
      location: "/surveys",
      permission: "survey",
    },
    {
      title: "Referrals",
      icon: <FaCircleCheck />,
      location: "/referrals",
      permission: "referral",
    },
    {
      title: "Grievances",
      icon: <FaExclamationTriangle />,
      location: "/grievances",
      permission: "grievance",
    },
    {
      title: "IJP Requests",
      icon: <FaExclamationTriangle />,
      location: "/ijp-requests",
      permission: "ijp_request",
    },
    {
      title: "Payments",
      icon: <FaDollarSign />,
      location: "/payments",
      permission: "payment",
    },
    {
      title: "Settings",
      icon: <IoSettingsOutline />,
      location: "/settings",
      permission: "settings",
    },
  ];

  return (
    <>
      {userData?.userType === "master" ? (
        <div className="flex flex-col gap-1 items-center w-full h-full overflow-y-scroll py-2 mb-10 md:mb-0 hide-scrollbar">
          {NavigationData.map((item, index) => (
            <NavLink
              key={index}
              className={({ isActive }) =>
                `px-2 py-2 rounded-sm w-full flex border border-transparent items-center gap-1.5 
              text-sm ${
                isActive
                  ? "bg-[#d8c9ae] text-[#575757]"
                  : "hover:border hover:border-[#f8f6f4] text-[#d8c9ae]"
              }`
              }
              to={item.location}
            >
              <span className="text-xl">{item.icon}</span>
              <p className="sm:hidden lg:block">{item.title}</p>
            </NavLink>
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-1 items-center w-full h-full overflow-y-scroll py-2 hide-scrollbar">
          {NavigationData.filter((item) =>
            permissions.some(
              (perm) => perm.resource === item.permission && perm.read
            )
          ).map((item, index) => (
            <NavLink
              key={index}
              className={({ isActive }) =>
                `px-2 py-2 rounded-sm w-full flex border border-transparent items-center gap-1.5 
            text-sm ${
              isActive
                ? "bg-[#d8c9ae] text-[#575757]"
                : "hover:border hover:border-[#f8f6f4] text-[#d8c9ae]"
            }`
              }
              to={item.location}
            >
              <span className="text-xl">{item.icon}</span>
              <p className="sm:hidden lg:block">{item.title}</p>
            </NavLink>
          ))}
        </div>
      )}

      {/* <PortalSelector/> */}
      {/* <div className="flex-row gap-1 items-start w-full p- hidden md:flex">
        <Link
          to="/sales/dashboard"
          className="flex items-start gap-2 text-white hover:underline rounded-md p-1 button border w-full hover:bg-[#d8c9ae] hover:text-[#39160d] transition-colors"
        >
          <SwatchBook /> Sales
        </Link>
        <Link
          to="/payroll/dashboard"
          className="flex items-start gap-2 text-white hover:underline rounded-md p-1 button border w-full hover:bg-[#d8c9ae] hover:text-[#39160d] transition-colors"
        >
          <SwatchBook /> Payroll
        </Link>
      </div> */}
      <div
        onClick={() => navigate("/account")}
        className="hidden md:flex text-white items-center gap-3 cursor-pointer px-3 py-2 rounded-md hover:bg-[#d8c9ae] hover:text-[#39160d] transition-colors border w-full"
      >
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-500 text-white uppercase">
          {userData?.firstName.charAt(0)}
        </div>
        <div className="flex flex-col">
          <span className="font-medium text-sm truncate">
            {userData?.firstName} {userData?.lastName}
          </span>
          <span className="font-medium text-[9px] ">{userData?.email}</span>
          {/* <span className="font-medium text-[11px] ">{userData?.role}</span> */}
        </div>
      </div>
    </>
  );
};

export default Sidebar;